import { render } from "./Edit-Cliente.vue?vue&type=template&id=cd7a59b4&scoped=true"
import script from "./Edit-Cliente.vue?vue&type=script&lang=js"
export * from "./Edit-Cliente.vue?vue&type=script&lang=js"

import "./Edit-Cliente.vue?vue&type=style&index=0&id=cd7a59b4&scoped=true&lang=css"
import "./Edit-Cliente.vue?vue&type=style&index=1&id=cd7a59b4&lang=css"
import "./Edit-Cliente.vue?vue&type=style&index=2&id=cd7a59b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd7a59b4"]])

export default __exports__